<template>
  <BasicModal
    wrap-class-name="rename-folder-modal"
    v-bind="$attrs"
    destroyOnClose
    :default-fullscreen="false"
    @register="register"
    @ok="handleOk"
    :confirm-loading="confirmLoading"
    :min-height="100"
    :title="title"
    :width="1000"
    :height="400"
  >
    <template v-if="true">
      <JsonEditorVue
        class="code-json-editor"
        v-model="resultInfo"
        language="'zh'"
        current-mode="code"
      />
    </template>
  </BasicModal>
</template>
<script lang="ts">
  import { defineComponent, ref } from 'vue';
  import { BasicModal, useModalInner } from '/@/components/Modal';
  import { useMessage } from '/@/hooks/web/useMessage';
  import JsonEditorVue from 'json-editor-vue3';

  export default defineComponent({
    components: { BasicModal, JsonEditorVue },
    emits: ['commit', 'register'],
    setup(propsprops, { emit }) {
      const resultInfo = ref<string>('');

      const title = ref<string>('json编辑器');

      const [register, { closeModal }] = useModalInner(async (data) => {
        resultInfo.value = data?.data;
      });

      const confirmLoading = ref<boolean>(false);

      const {
        createMessage: { success, error },
      } = useMessage();

      // 确认
      const handleOk = async () => {
        confirmLoading.value = true;

        try {
          emit('commit', resultInfo.value);
        } catch (errorInfo) {
          console.error('Failed:', errorInfo);
        } finally {
          confirmLoading.value = false;
          closeModal();
        }
      };

      return {
        register,
        resultInfo,
        handleOk,
        confirmLoading,
        title,
        labelCol: { span: 3 },
      };
    },
  });
</script>
<style lang="less" scoped>
  .rename-folder-modal {
    .ant-modal {
      .ant-modal-body {
        padding: 0px;
      }
    }
    .code-json-editor {
      height: 390px;

      /* jsoneditor右上角默认有一个链接,加css去掉 */
      :deep(.jsoneditor-poweredBy) {
        display: none !important;
      }
    }
  }
</style>
